<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline"
    :class="[width, height]"
    viewBox="0 0 37.074 37.074"
  >
    <g id="Group_296" data-name="Group 296" transform="translate(-396.966 -1060.812)">
      <path
        id="Dark_Blue"
        data-name="Dark Blue"
        d="M429.406,1097.886H401.6a4.636,4.636,0,0,1-4.635-4.634v-27.806a4.636,4.636,0,0,1,4.635-4.634h27.805a4.636,4.636,0,0,1,4.634,4.634v27.806A4.636,4.636,0,0,1,429.406,1097.886Z"
        fill="#1da1f2"
      />
      <path
        id="Logo_FIXED"
        data-name="Logo — FIXED"
        d="M412.314,1090.222a13.435,13.435,0,0,0,13.523-13.523c0-.2,0-.408-.009-.611a9.69,9.69,0,0,0,2.373-2.465,9.6,9.6,0,0,1-2.734.75,4.781,4.781,0,0,0,2.095-2.632,9.472,9.472,0,0,1-3.022,1.149,4.754,4.754,0,0,0-8.221,3.253,5.252,5.252,0,0,0,.121,1.085,13.5,13.5,0,0,1-9.8-4.968,4.771,4.771,0,0,0,1.474,6.349,4.818,4.818,0,0,1-2.151-.593v.065a4.763,4.763,0,0,0,3.81,4.662,4.767,4.767,0,0,1-2.141.083,4.753,4.753,0,0,0,4.439,3.3,9.532,9.532,0,0,1-5.9,2.039,9.1,9.1,0,0,1-1.131-.065,13.52,13.52,0,0,0,7.276,2.122"
        transform="translate(-1.111 -1.456)"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-9'
    },
    height: {
      type: String,
      default: 'h-9'
    }
  }
}
</script>
